import { render, staticRenderFns } from "./WPHAllianceAuthorization.vue?vue&type=template&id=50bd968c"
import script from "./WPHAllianceAuthorization.vue?vue&type=script&lang=js"
export * from "./WPHAllianceAuthorization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50bd968c')) {
      api.createRecord('50bd968c', component.options)
    } else {
      api.reload('50bd968c', component.options)
    }
    module.hot.accept("./WPHAllianceAuthorization.vue?vue&type=template&id=50bd968c", function () {
      api.rerender('50bd968c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/allianceAuthorization/WPHAllianceAuthorization.vue"
export default component.exports